<template>
    <div id="status"  type='button' :class="{'h-pm-statustemp': true, 'h-pm-e-realcolor': this.$data.data.counterTimelyMod == real, 'h-pm-e-norealcolor': this.$data.data.counterTimelyMod == noreal,
    'h-pm-e-realOrNocolor': this.$data.data.counterTimelyMod == realOrNo}">
        <span :class="{'h-pm-e-txt-realcolor': this.$data.data.counterTimelyMod == real, 'h-pm-e-txt-norealcolor':this.$data.data.counterTimelyMod == noreal,
        'h-pm-e-txt-realOrNocolor': this.$data.data.counterTimelyMod == realOrNo}">
            {{this.$data.data.FailureOrNo}}
        </span>
    </div>

</template>
<script>

const NONREAL = 1;
const REAL = 2;
const REALORNO = 3;

export default {
  name: 'realTemplate',
  data() {
    return {
      real: REAL,
      noreal: NONREAL,
      realOrNo: REALORNO,
    };
  },

};
</script>
